export default __webpack_public_path__ + "static/media/box1-ar.1fe12f15.svg";